export default {
  light: {
    $type: 'light',
    globalBackground: '#f2f4fa',
    globalColor: '#55586a',
    fadedColor: '#6b768b',
    background: '#fff',
    borderColor: 'rgba(0, 32, 128, 0.12)',
    backgroundDark: '#e2eaf2',
    modalBackground: '#fff',
    shadowColor: 'rgba(0, 16, 64, 0.2)',
    red: '#ff1964',
    blue: '#4a7eff',
    tippy: 'google',
    scale: [
      '#f2246c',
      '#e9557f',
      '#ff7d8f',
      '#acb5c5',
      '#85c89e',
      '#6bbb94',
      '#00b781',
    ],
  },
  dark: {
    $type: 'dark',
    globalBackground: '#262c45',
    globalColor: '#d9eeff',
    fadedColor: '#8b98e1',
    background: '#2c3451',
    borderColor: '#181b2e',
    backgroundDark: '#1e2238',
    modalBackground: 'radial-gradient(circle at 20% 20%, #2d3451, #262b43)',
    shadowColor: 'rgba(0, 2, 4, 0.3)',
    red: '#ff578e',
    blue: '#76aaff',
    tippy: 'translucent',
    scale: [
      '#ff6a9e',
      '#f74a86',
      '#cf5274',
      '#646c8c',
      '#5ba58f',
      '#2cca9c',
      '#10dca0',
    ],
  },
}
